// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Uaa-z","narrowOptionButtons":"Vaa-z","noOptions":"Waa-z"};